import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import WidgetMarketNews from './markets-news';

export const MarketsNewsWidget = () => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <WidgetMarketNews />
    </QueryClientProvider>
  );
};
